<template>
    <!-- Your Page Content Goes Here-->
    <div class="page-content header-clear-medium">

		<div class="card card-style">
			<div class="content">
				<h1 class="text-center font-800 font-22 mb-2 color-blue-dark">Selamat Datang di aplikasi PARENTAL</h1>
				<!-- <p class="text-center font-16 mt-n2 mb-2">(Monitoring Kinerja dan Tunjangan)</p>
                <p class="text-center font-13 mt-n2 mb-3">Cabdindik Banyuwangi</p> -->

				<!-- <div class="alert alert-danger" v-if="errors.message">
					{{ errors.message }}
				</div> -->

				<div class="card card-style bg-fade-blue border border-fade-blue alert alert-dismissible show fade p-0 mb-3">
					<div class="content my-3">
						<div class="d-flex">
							<div class="align-self-center">
								<i class="bi bi-info-square font-33 color-blue-dark d-block"></i>
							</div>
							<div class="align-self-center">
								<p class="color-blue-dark mb-0 font-500 font-14 ps-3 pe-4 line-height-s">
									Perhatian, Silahkan Masukan NISN <br> untuk Mengirim OTP Ke Whatsapp Anda. 
								</p>
							</div>
						</div>
					</div>
				</div>

				<div class="form-custom form-label form-icon mb-3">
					<i class="bi bi-person-circle font-14"></i>
					<input type="text" v-model="data.nisn" :disabled="status_send_otp" class="form-control rounded-xs" placeholder="NISN" required />
					<label for="c1" class="color-theme">NISN</label>
					<span>(required)</span>
				</div>
				<button :disabled="status_send_otp" @click="sendRequestOtp" class='w-100 btn rounded-sm btn-m bg-green-dark text-uppercase font-700 mt-4 mb-3 btn-full shadow-bg shadow-bg-s'>Meminta OTP</button>
				<div class="d-flex">
					<!-- <div>
						<a href="page-forgot-1.html" class="color-blue-dark opacity-90 font-12">user dan password saya?</a>
					</div>
					<div class="ms-auto">
						<a href="page-register-1.html" class="color-blue-dark opacity-90 font-12">Tutorial Aplikasi Sritanjung</a>
					</div> -->
				</div>
			</div>
		</div>

    </div>
	<!-- End of Page Content-->
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'

export default {
    name: 'Login',
    data() {
        return {
			data: {
				nisn: null,
			},
			status_send_otp: false,
		}
    },
	created() {
		if (this.isAuth) {
			this.$router.push({name: 'home'})
		}
	},    
	computed: {
		...mapGetters(['isAuth']),
		...mapState(['errors'])
	},
	methods: {
		...mapActions('otp', ['sendOtp']),
		...mapMutations(['CLEAR_ERRORS']),
		sendRequestOtp() {
			this.status_send_otp = true
			this.sendOtp(this.data.nisn)
				.then(() => {
					this.$router.push({name: 'login_otp', query: { nisn: this.data.nisn }})
					this.status_send_otp = false
				})
				.catch(() => {
					this.status_send_otp = false
				})
		},
	},
}
</script>